var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from "react";
import TriaphonMDXEditor from "./TriaphonMDXEditor";
import FullscreenContainer from "./primitives/FullscreenContainer";
export default function TriaphonMDXEditorWithFullscreen(props) {
    const { actions } = props, editorProps = __rest(props, ["actions"]);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const currentMarkdownRef = useRef(editorProps.field.value || "");
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape" && isFullscreen) {
                setIsFullscreen(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isFullscreen]);
    useEffect(() => {
        if (isFullscreen) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isFullscreen]);
    const handleChange = (val) => {
        currentMarkdownRef.current = val;
        editorProps.field.onChange(val);
    };
    const fieldWithTracking = Object.assign(Object.assign({}, editorProps.field), { onChange: handleChange });
    const editorContent = (React.createElement(TriaphonMDXEditor, Object.assign({}, editorProps, { field: fieldWithTracking, defaultValue: currentMarkdownRef.current, isFullscreen: isFullscreen, setIsFullscreen: setIsFullscreen, className: isFullscreen ? "triaphon-mdx-editor--fullscreen" : undefined })));
    if (isFullscreen) {
        return React.createElement(FullscreenContainer, { actions: actions }, editorContent);
    }
    else {
        return editorContent;
    }
}
